import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { apiParseCV } from 'api/managerCandidate';
import { HTTP_OK } from 'constants/StatusCode';
import { CV_PARSER_DISABLED, getCvFillValues } from 'helpers/cvParser';

/**
 * Gọi AI đọc CV vừa upload rồi điền sẵn các ô còn trống của form tạo ứng viên.
 * onFilled({ values, languages }) cho modal xử lý field không tự nhận setValue (ngày sinh, trường, ngoại ngữ).
 */
export function useParseCv({ getValues, setValue, getOptions, onFilled, hasLanguages = true }) {
  const { t } = useTranslation();
  const [result, setResult] = useState(null);

  const { mutate, isLoading } = useMutation((url) => apiParseCV({ url, options: getOptions() }), {
    onSuccess: (response) => {
      const body = response?.data;
      if (body?.status !== HTTP_OK || !body?.data) {
        // Chưa bật AI thì im lặng, HR nhập tay như cũ
        setResult(
          body?.error === CV_PARSER_DISABLED ? null : { error: body?.message || t('managerCandidate.aiParseFail') },
        );
        return;
      }
      const { values, languages } = getCvFillValues(body.data, getValues(), hasLanguages);
      Object.keys(values).forEach((name) => setValue(name, values[name], { shouldValidate: true }));
      onFilled && onFilled({ values, languages });
      setResult({ count: Object.keys(values).length + (languages ? 1 : 0) });
    },
    onError: () => {
      setResult({ error: t('managerCandidate.aiParseFail') });
    },
  });

  const parseCv = (url) => {
    setResult(null);
    if (url) mutate(url);
  };

  return { parseCv, isParsingCv: isLoading, parseCvResult: result, resetParseCv: () => setResult(null) };
}
